import React from 'react'
import dayjs from 'dayjs'
import { Value } from '../../elements'

export const getMobileFields = () => [
  {
    key: 'date_work_completion',
    label: 'Дата работ (план)',
    render: (val) => (val ? dayjs(val).format('DD.MM.YYYY') : <Value data={val} />),
  },
  {
    key: 'address',
    label: 'Адрес',
    render: (val) => <Value data={val} />,
  },
  {
    key: 'responsible_name',
    label: 'Ответственный',
    render: (val) => (Array.isArray(val) ? val.join(', ') : <Value data={val} />),
  },
  {
    key: 'phone',
    label: 'Телефон',
  },
]


